import { render, staticRenderFns } from "./restInvoiceItems.vue?vue&type=template&id=735af599&scoped=true&"
import script from "./restInvoiceItems.vue?vue&type=script&lang=js&"
export * from "./restInvoiceItems.vue?vue&type=script&lang=js&"
import style0 from "./restInvoiceItems.vue?vue&type=style&index=0&id=735af599&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735af599",
  null
  
)

export default component.exports